/**
 * Loose text matching for user-facing file/name filters (MYAC-883).
 *
 * Case-, accent-, separator- and word-order-insensitive: "evaluation 2024"
 * matches "Évaluation fournisseurs 2024.xlsx", "capa log" matches
 * "2024_CAPA-log_v3.xlsx". The query is split into alphanumeric tokens and
 * every token must appear somewhere in the normalized text.
 */

export function normalizeLoose(value: string): string {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
}

export function matchesLoose(text: string, query: string): boolean {
  const tokens = normalizeLoose(query).split(/[^a-z0-9]+/).filter(Boolean)
  if (!tokens.length) return true
  const normalized = normalizeLoose(text)
  return tokens.every((t) => normalized.includes(t))
}
